<template lang="pug">
  .table-responsive
    table#tbMovimientos.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Tag
          th 
            | Fecha Movimiento
          th 
            | Cargo
          th 
            | Abono
          th 
            | Clase
          th 
            | Cruce
      tbody
        tr(v-for="(mov, index) in movs" :key="mov.id")
          td.is-size-7
            a.button.is-black.is-rounded.is-small {{ index + 1 }}
          td.is-size-7
            span.tag.is-black {{ mov.tag }}
            br
            |  {{ mov.usuario }}
          td.is-size-7
            span.tag
              | {{ mov.fecha }}
          td.is-size-7(v-if="mov.cargo <= 0")
            |
          td.is-size-7(v-else)
            span.tag.is-black
              | {{ mov.cargo | currency }}
          td.is-size-7(v-if="mov.abono <= 0")
            |
          td.is-size-7(v-else)
            span.tag.is-black
              | {{ mov.abono | currency }}
          td.is-size-7
            span.tag(:class="mov.clase != '1' ? 'is-danger' : 'is-light' ")
              | {{ mov.clase != '1' ? 'Inválido' : 'Válido' }}
          td.is-size-7
            span.tag.is-black
              | {{ mov.cruce }}
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
  export default {
    name: 'TbMovimientosTags',
    props: {
      movs: {
        type: Array,
        default: []
      },
      movSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: true,
        itemsSelected: {},
        isDisabled: true,
      }
    },
    watch: {
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      movSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.movSel)
      },
    },
    methods: {
      iniciarComponente () {

      },
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_MovimientosTags.vue